import {
  Component,
  WritableSignal,
  inject,
  signal,
  computed,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal,
} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {
  MatRadioButton,
  MatRadioGroup,
} from '@angular/material/radio';
import {FormsModule} from '@angular/forms';
import {
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import moment from 'moment';
import {FormWrapperComponent} from '../form-wrapper/form-wrapper.component';
import {VoteValue} from '../../enums/vote-value.enum';
import {formatDateISO} from '../../functions/utils';
import {AlertsService} from '../../services/alerts/alerts.service';
import {Constants} from '../../constants/constants';
import {TimezoneComponent} from '../timezone/timezone.component';

@Component({
  selector: 'app-voting-form',
  imports: [
    TranslatePipe,
    FormWrapperComponent,
    TimezoneComponent,
    MatRadioButton,
    MatRadioGroup,
    FormsModule,
    MatButton
  ],
  templateUrl: './voting-form.component.html',
  styleUrl: './voting-form.component.scss',
})
export class VotingFormComponent {

  private readonly alerts: AlertsService = inject(AlertsService);

  private readonly translate: TranslateService = inject(TranslateService);

  public readonly voted: InputSignal<boolean> = input<boolean>(false);

  public readonly votedDate: InputSignal<string> = input<string>('');

  public readonly voteDeadline: InputSignal<string> = input<string>('');

  public readonly deadLineEnabled: InputSignal<boolean> = input<boolean>(false);

  public readonly previewMode: InputSignal<boolean> = input<boolean>(false);

  public readonly decisionMade: OutputEmitterRef<VoteValue> = output<VoteValue>();

  public readonly votedDateStr: Signal<string> = computed(() => formatDateISO(this.votedDate()));

  public readonly voteDeadlineStr: Signal<string> = computed(() => formatDateISO(this.voteDeadline()));

  protected readonly votingDecision: WritableSignal<VoteValue | ''> = signal('');

  protected readonly VoteValue = VoteValue;

  onDecisionDone(): void {
    const decision = this.votingDecision();
    if (decision) {
      this.decisionMade.emit(decision);
    } else {
      this.alerts.showInfo({
        statusText: this.translate.instant('voting.no_choice_done_error_type'),
        message: this.translate.instant('voting.please_provide_your_voting_choice'),
      });
    }
  }

  isDeadlinePassed(): boolean {
    return this.deadLineEnabled() && moment().utc().isAfter(moment(this.voteDeadline()).utc());
  }

  updateVotingDecision(value: VoteValue): void {
    this.votingDecision.set(value);
  }

  protected readonly Constants = Constants;

}
